<div id="assign-sheets">
    <div class="fullpage-sheet-viewer">
        <app-sheet-view [sheet]="sheet" [showExercices]="false" [showExamination]="false" [filterByStudent]=""
            *ngIf="sheet"></app-sheet-view>
        <i class="material-icons back-btn" routerLink="../..">arrow_back</i>
    </div>

    <!-- Section des exercices liés à la fiche -->
    @if (sheet) {
    <div class="exercises-section">
        <h2 class="exercises-title">Exercises related to this sheet</h2>
        
        @if (exercisesLoading) {
        <div class="exercises-loading">
            <span class="loader-wheel-blue"></span>
            <span class="loading-message" translate>Loading exercises...</span>
        </div>
        } @else if (exercises.length > 0) {
        <div class="exercises-table-container">
            <table class="exercises-table">
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>Level</th>
                        <th>Duration (min)</th>
                        <th>Preview</th>
                    </tr>
                </thead>
                <tbody>
                    @for (exercise of exercises; track exercise.id) {
                    <tr>
                        <td>{{ exercise.id }}</td>
                        <td class="capitalize">{{ exercise.difficulty }}</td>
                        <td>{{ exercise.duration }}</td>
                        <td>
                            <button class="preview-btn" (click)="toggleExercisePreview(exercise.id)" [disabled]="isExerciseQuestionsLoading(exercise.id)">
                                <span class="loader-wheel-blue" *ngIf="isExerciseQuestionsLoading(exercise.id)"></span>
                                <span>View</span>
                                <mat-icon class="icon" *ngIf="!isExerciseQuestionsLoading(exercise.id)">{{ isExercisePreviewVisible(exercise.id) ? 'expand_less' : 'expand_more' }}</mat-icon>
                            </button>
                        </td>
                    </tr>

                    <!-- Preview de l'exercice -->
                    @if (isExercisePreviewVisible(exercise.id)) {
                    <tr>
                        <td colspan="4">
                            @if (isExerciseQuestionsLoading(exercise.id)) {
                            <div class="questions-loading">
                                <span class="loader-wheel-blue"></span>
                                <span class="loading-message" translate>Loading questions...</span>
                            </div>
                            } @else if (getExerciseDetails(exercise.id)) {
                            <app-exercice-preview [exercice]="getExerciseDetails(exercise.id)"></app-exercice-preview>
                            }
                        </td>
                    </tr>
                    }
                    }
                </tbody>
            </table>

            <!-- Bouton "Load more" pour la pagination -->
            @if (exercisesData?.next) {
            <div class="load-more-container">
                <button class="preview-btn" (click)="loadMoreExercises()" [disabled]="exercisesLoadMoreLoading">
                    <span class="loader-wheel-blue" *ngIf="exercisesLoadMoreLoading"></span>
                    <span>Load More Exercises</span>
                </button>
            </div>
            }
        </div>
        } @else {
        <div class="no-exercises">
            <p>No exercises available for this sheet.</p>
        </div>
        }
    </div>
    }
</div>